import DatePicker from '@components/DatePicker';
import SelectInput from '@components/SelectInput/SelectInput';
import PasswordInput from '@components/TextInput/PasswordInput';
import TextInput from '@components/TextInput/TextInput';

export const informationConfig = [
  {
    name: 'information.title',
    label: 'Booking.title',
    component: SelectInput,
    options: 'titleOptions'
  },
  {
    name: 'information.firstName',
    label: 'SignIn.firstName',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'information.lastName',
    label: 'SignIn.lastName',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'information.academicTitle',
    label: 'MyProfile.academicTitle',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'information.birthDate',
    label: 'MyProfile.birthDate',
    component: DatePicker
  },
  {
    name: 'information.birthPlace',
    label: 'MyProfile.birthPlace',
    component: TextInput,
    isIcon: true
  }
];

export const organizationalDataConfig = [
  {
    name: 'organizationalData.departmentName',
    label: 'MyProfile.departmentName',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'organizationalData.job',
    label: 'MyProfile.job',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'organizationalData.companyName',
    label: 'MyProfile.companyName',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'organizationalData.personalNumber',
    label: 'MyProfile.personalNumber',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'organizationalData.costCenter',
    label: 'MyProfile.costCenter',
    component: TextInput,
    isIcon: true
  }
];

export const emailConfig = [
  {
    name: 'type',
    label: 'CourseDetails.type',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'email',
    label: 'Booking.email',
    component: TextInput,
    isIcon: true
  }
];

export const addressConfig = [
  {
    name: 'type',
    label: 'CourseDetails.type',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'street',
    label: 'SignIn.street',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'number',
    label: 'Booking.number',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'postCode',
    label: 'SignIn.postcode',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'state',
    label: 'MyProfile.state',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'city',
    label: 'App.city',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'poBox',
    label: 'MyProfile.poBox',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'country',
    label: 'App.country',
    component: SelectInput,
    options: 'countryOptions'
  },
  {
    name: 'region',
    label: 'Booking.region',
    component: SelectInput,
    options: 'regionOptions',
    style: { marginRight: '1rem' }
  }
];

export const communicationConfig = [
  {
    name: 'type',
    label: 'CourseDetails.type',
    component: TextInput,
    isIcon: true
  },
  {
    name: 'phone',
    label: 'RegistrationForm.phone',
    component: TextInput,
    isIcon: true
  }
];

export const resetPasswordConfig1 = [
  {
    name: 'currentPassword',
    label: 'MyProfile.currentPassword',
    component: PasswordInput,
    required: true,
    sm: 12,
    margin: 'normal'
  },
  {
    name: 'newPassword',
    label: 'MyProfile.newPassword',
    component: PasswordInput,
    required: true,
    sm: 12,
    margin: 'normal'
  }
];

export const resetPasswordConfig2 = [
  {
    name: 'confirmNewPassword',
    label: 'MyProfile.confirmPassword',
    component: PasswordInput,
    required: true,
    sm: 12,
    margin: 'normal'
  }
];
